(() => {
  'use strict';
  if (window.routineReviewsInitialized) return;
  window.routineReviewsInitialized = true;
  const controllers = new WeakMap();
  function init(root) {
    if (controllers.has(root)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const track = root.querySelector('[data-review-track]');
    const previous = root.querySelector('[data-review-previous]');
    const next = root.querySelector('[data-review-next]');
    const position = root.querySelector('[data-review-position]');
    const cards = [...track.querySelectorAll('.lp-review')];
    function update() {
      const overflowing = track.scrollWidth > track.clientWidth + 4;
      previous.hidden = next.hidden = !overflowing;
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const width = cards[0].getBoundingClientRect().width + gap;
      const first = Math.round(track.scrollLeft / width) + 1;
      const count = Math.max(1, Math.round((track.clientWidth + gap) / width));
      const last = Math.min(cards.length, first + count - 1);
      const range = `${first}${last > first ? `–${last}` : ''}`;
      const positionLabel = root.dataset.reviewPositionLabel;
      position.textContent = overflowing ? (positionLabel ? positionLabel.replace('__range__', range).replace('__total__', String(cards.length)) : `Reviews ${range} of ${cards.length}`) : '';
    }
    function move(direction) {
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const width = cards[0].getBoundingClientRect().width + gap;
      track.scrollBy({ left: direction * width, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    previous.addEventListener('click', () => move(-1), { signal });
    next.addEventListener('click', () => move(1), { signal });
    track.addEventListener('scroll', update, { passive: true, signal });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    controller.signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    controllers.set(root, controller);
    update();
  }
  const initAll = (scope = document) => scope.querySelectorAll('[data-routine-reviews]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-routine-reviews]').forEach(root => { controllers.get(root)?.abort(); controllers.delete(root); }));
})();
